<template>
    <div class="animated fadeIn" v-if="isBookingLoaded()">
        <div class="row">
            <div class="col col-md-10 col-lg-8 offset-md-1 offset-lg-2">
                <h3>Внешняя бронь {{booking.external_id}} (к путевке <a
                    :href="$router.resolve({ path:voucherPage(booking.voucher_id)}).href">#{{booking.voucher_id}}</a>)
                </h3>
                <b-card>
                    <p>
                        Агентство: {{booking.company.title}}<br>
                        Агент: {{booking.user.name_}} {{booking.user.patro}} {{booking.user.surname}}
                        <template v-if="booking.user.email">, &nbsp; <a :href="'mailto:'+booking.user.email">{{booking.user.email}}</a>
                        </template>
                        <template v-if="booking.user.local_phone_stat">, &nbsp; тел: <a
                            :href="'tel:'+booking.user.local_phone_stat">{{booking.user.local_phone_stat}}</a>
                        </template>
                        <template v-if="booking.user.phone_stat">, &nbsp; тел: <a
                            :href="'tel:'+booking.user.phone_stat">{{booking.user.phone_stat}} </a></template>
                        <template v-if="booking.user.phone_mobi">, &nbsp; тел: <a
                            :href="'tel:'+booking.user.phone_mobi">{{booking.user.phone_mobi}}</a></template>
                        <br>
                        Объект размещения: <a href="#" @click.prevent="onShowHotelDialog(booking.voucher.hotel.id)">{{booking.voucher.hotel.title}}
                        ({{booking.voucher.city.title}})</a>
                        <template v-if="is_admin"> &nbsp;
                            <a :href="$router.resolve({path:'/tech/hotels/info/'+booking.voucher.hotel.id}).href">(редактировать)</a>
                        </template>

                        <br>

                        <template v-if="booking.booker_id===0">Бронируется напрямую<br></template>
                        <template v-if="booking.booker_id===1">Бронируется через Профкурорт, бронь в Профкурорте
                            {{booking.external_id}}<br></template>
                        Даты бронирования: с {{printDate(booking.start_at)}} по {{printDate(booking.end_at)}}
                    </p>

                    <template v-if="ex_data && ex_data.reports">
                        <p>
                            <a :href="ex_data.reports.reporturl" target="_blank">Ваучер</a><br>
                            <a :href="ex_data.reports.reporturlDetail" target="_blank">Подробная информация</a><br>
                        </p>
                    </template>

                    <div class="row">
                        <div class="col-12">
                            <b-form-group>
                                <button class="btn btn-secondary" @click="onExit"><i class="icon-logout"></i> Вернуться </button> &nbsp;
                                <button class="btn btn-primary" @click="onUpdate"><i class="fa fa-save"></i> Обновить </button> &nbsp;
                                <button class="btn btn-danger" @click="onCancel"><i class="fa fa-save"></i> Отменить </button> &nbsp;
                                <button class="btn btn-success" @click="onPay"><i class="fa fa-save"></i> Оплатить </button>
                            </b-form-group>
                            <small>
                                Обновить - читает даные с профкурорта<br>
                            </small>
                        </div>
                    </div>

                    <template v-if="ex_data">
                        <h3>Техническая информация</h3>
                        <pre class="pre-scrollable">{{ JSON.stringify(ex_data, null, 4) }}</pre>
                    </template>

                    <template v-if="ex_data">
                        <h3>Комментарий</h3>
                        <pre class="pre-scrollable">{{ booking.comment }}</pre>
                    </template>


                </b-card>
            </div>
        </div>
        <hotel-info-dialog :hotelid='hotelInfoId' v-model="showHotelDialog" @hide="onHideHotelDialog"/>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {functions} from '@/functions.js';
    import {functions_booking} from '@/functions/booking.js';
    import {functions_loaders} from '@/functions_loaders.js';
    import {functions_mimetypes} from '@/functions_mimetypes.js';
    import {CONSTANTS} from '@/constants';
    import HotelInfoDialog from '@/dialogs/HotelInfoDialog'

    export default {
        name: 'NsbManagerBooking',
        components: {HotelInfoDialog,},
        mixins: [functions, functions_loaders, functions_mimetypes, functions_booking],
        data: function () {
            return {
                booking_id: null,
                document_file: null,
                document_type: 1,
                total_booking_value: null,
                showHotelDialog: false,
                hotelInfoId: null,
                wait_for_invoice: false,
                ex_data: null,
            }
        },
        methods: {
            afterBookingLoaded: function () {
                this.booking.invoice_date = this.parseDate(this.booking.invoice_date);
                this.booking.redemption_date = this.parseDate(this.booking.redemption_date);
                this.booking.bill_date = this.parseDate(this.booking.bill_date);
                this.booking.wait_invoice_date = this.parseDate(this.booking.wait_invoice_date);
                this.booking.bill_redemption_date = this.parseDate(this.booking.bill_redemption_date);
                this.wait_for_invoice = !!this.booking.wait_invoice_date;
                this.ex_data = JSON.parse(this.booking.data);
                console.log("this.booking.wait_invoice_date=", this.booking.wait_invoice_date)
                console.log("this.booking.wait_for_invoice=", this.wait_for_invoice);
            },
            onChangeFee: function () {
                this.calculate();
                this.calculate_tbv();
            },
            onShowHotelDialog(hotel_id) {
                this.hotelInfoId = hotel_id;
                this.showHotelDialog = true;
            },
            onHideHotelDialog: function () {
                this.hotelInfoId = null;
            },

            doGoBack: function () {
                this.$router.back();
                this.$router.push({path: this.bookingsPage});
            },
            onExit: function () {
                this.doGoBack();
            },

            onUpdate: function () {
                console.log("onUpdate");
                this.updateBookingEx(this.booking_id, this.afterBookingLoaded)
            },
            onCancel: function () {
                this.cancelBookingEx(this.booking_id, this.afterBookingLoaded)
            },
            onPay: function () {
                this.payBookingEx(this.booking_id, this.afterBookingLoaded)
            },

            onWaitFinished: function () {
                // this.booking.fee_included
                // this.booking.fee_to_be_payed
                // this.fee_included = this.hotelx.sys_invoice_type===CONSTANTS.INVOICE_INCLIDES_FEE;
                // this.fee_to_be_payed = this.hotelx.sys_payment_type===CONSTANTS.PAYMENT_WITH_FEE;
            },
        },
        computed: {
            not_fee_to_be_payed: {
                get: function () {
                    return !this.booking.fee_to_be_payed
                },
                set: function (newValue) {
                    this.booking.fee_to_be_payed = newValue ? 0 : 1;
                }
            },
            invoiceValueClass: function () {
                return ''
            },
            feeValueClass: function () {
                return ''
            },
            controlValues: function () {
                if (this.booking.fee_included) {
                    console.log(this.booking.voucher.summa_full * 100, this.booking.invoice_value)
                    return this.booking.voucher.summa_full * 100 == this.booking.invoice_value;
                } else {
                    console.log(this.booking.voucher.summa_full * 100, this.booking.invoice_value, this.booking.fee_value)
                    return this.booking.voucher.summa_full * 100 == this.booking.invoice_value + this.booking.fee_value;
                }
            },

            invoice_value: {
                set: function (val) {
                    this.booking.invoice_value = Math.round(val * 100);
                },
                get: function () {
                    return this.booking.invoice_value / 100;
                },
            },
            to_pay_value: {
                set: function (val) {
                    this.booking.to_pay_value = Math.round(val * 100);
                },
                get: function () {
                    return this.booking.to_pay_value / 100;
                },
            },
            fee_value: {
                set: function (val) {
                    this.booking.fee_value = Math.round(val * 100);
                },
                get: function () {
                    return this.booking.fee_value / 100;
                },
            },
            bill_value: {
                set: function (val) {
                    this.booking.bill_value = Math.round(val * 100);
                },
                get: function () {
                    return this.booking.bill_value / 100;
                },
            },

            _summa_full: {
                set: function (val) {
                },
                get: function () {
                    return this.booking.voucher.summa_full / 100;
                }
            },

        },
        created: function () {
            this.booking_id = this.$router.currentRoute.params.booking_id;
            this.loadBooking(this.booking_id, this.afterBookingLoaded)
        }
    }
</script>


https://report.ihbooking.ru/result?report=LET_profkur_fiz_test.fr3&Param1=prj_name&Param2=letcod&format=PDF&userid=usrid&dbhost=192.168.10.2&rnd=0.679234731011093
https://report.ihbooking.ru/result?report=LET_profkur_fiz_test.fr3&Param1=profkurort&Param2=1621135&format=PDF&userid=3952&dbhost=192.168.10.2&rnd=0.679234731011093
https://report.ihbooking.ru/result?report=exchangeVoucher_2018.fr3&Param1=profkurort&Param2=1621135&format=PDF&userid=3952&dbhost=192.168.10.2&rnd=0.10333843762055
